import Axios from 'axios'
import config from '../config'

export const getByCode = async ({ code }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/coupon-codes?code=${code}`
  const response = await Axios.get(URL)
  return response.data
}



// WEBPACK FOOTER //
// ./src/api/couponCode.js